import Routes from "../Routes";

import ProductsPlacesAutocomplete from "./ProductsPlacesAutocomplete";
import ProductRouteTransportationMethodOptions from "./ProductRouteTransportationMethodOptions";

import { fetchAddressesGcd } from "../../../helpers/utils/apiCalls";

const ProductRouteInput = ({ route, editRoute, disabled, footprintShared }) => {
  const { legs } = route;

  const findNewLegs = async ({ legs, from, to }) => {
    const { gcd } = await fetchAddressesGcd(from, to);

    return legs.map((leg, idx) =>
      !idx
        ? {
            ...leg,
            distanceKm: gcd
          }
        : leg
    );
  };

  const buildLeg = async (from, to) => {
    const { gcd } = await fetchAddressesGcd(from, to);
    return {
      from,
      to,
      distanceKm: gcd
    };
  };

  const onEditLeg = (value, legIdx) =>
    legs.map((leg, idx) =>
      idx === legIdx ? { ...leg, transportationMethod: value } : leg
    );

  return (
    <Routes
      route={route}
      editRoute={editRoute}
      DestinationRowComponent={ProductsPlacesAutocomplete}
      LegColumnComponent={ProductRouteTransportationMethodOptions}
      legColumnComponentProps={{ footprintShared }}
      onEditLeg={onEditLeg}
      findNewLegs={findNewLegs}
      buildLeg={buildLeg}
      disabled={disabled}
    />
  );
};
export default ProductRouteInput;
